
import React from "react";
import "./HolidayCleaningService.css";

const HolidayCleaningService = () => {
  return (
    <div className="holidaycleaning-cleaning-container">
      <h1>Enjoy the Holidays — Let Us Handle the Cleaning</h1>
      <p>Our Holiday Cleaning service ensures your home is festive, fresh, and guest-ready. Whether it's before or after a gathering, we bring the sparkle so you can focus on the joy.</p>
      <h2>What’s Included:</h2>
      <ul>
        <li>Cleaning common and guest areas</li>
<li>Polishing surfaces and décor spaces</li>
<li>Sanitizing bathrooms and kitchen</li>
<li>Trash removal and tidying</li>
<li>Extra attention to detail for a festive feel</li>

      </ul>
    </div>
  );
};

export default HolidayCleaningService;
